<template>
    <form @submit.prevent="sendData()" method="post" enctype="multipart/form-data">
        <InputFile labelText="Attestation de présence ou certification *"></InputFile>

        <h3>Confidentialité des données</h3>
        <div class="check">
            <input v-model="isChecked" type="checkbox" name="check" id="checkbox-confidentiality" />
            <label for="checkbox-confidentiality">
                Je consens à ce que le SUP-H conserve ces informations pour répondre à ma demande d'adhésion.
                Ces données sont utilisées également à des fins statistiques.
                Ces données ne feront l'objet d'aucune publication.
            </label>
        </div>

        <div class="div-btn">
            <button :disabled="disabledButton" id="send-data">Envoyer ma demande d'adhésion</button>
        </div>
    </form>
</template>

<script>
import { computed, ref } from "vue";
import { state, send } from "../../store";
import InputFile from "../Inputs/InputFile.vue";

export default {
    name: 'LastStep',
    components: { InputFile },

    setup() {
        const isChecked = ref(false);

        const disabledButton = computed(() => {
            if (isChecked.value === true && state.files.length > 0) {
                return false;
            }
            return true;
        });

        const sendData = () => {
            send();
        }

        return { isChecked, disabledButton, state, sendData }
    }
}
</script>

<style lang='scss' scoped>
@import "../../scss/variables";

form {
    text-align: left;

    .check {
        display: flex;
        align-items: center;
        label {
            padding-left: 0.5rem;
        }
    }
}

.div-btn {
    text-align: center;
    margin-top: 1rem;
    @include buttonStyle($base-color, 2px solid $base-color, white);
}
</style>